"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchSetToUrl = void 0;
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
var UpdateSaveSearchCallSaga_1 = require("@/pages/savesearch/sagas/UpdateSaveSearchCallSaga");
var searchQueryToUrl_1 = require("@/transformers/searchQueryToUrl");
var LayoutState_init_1 = require("@/pages/common/states/LayoutState.init");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var SfavSaveSearchSaga_1 = require("@/pages/search/sagas/SfavSaveSearchSaga");
var HfilterDistrictItem_init_1 = require("@/pages/search/states/HfilterDistrictItem.init");
exports.searchSetToUrl = function (searchSet, currentHfilter, currentLayoutState) {
    var layoutstate = currentLayoutState || LayoutState_init_1.defaultLayoutState;
    var defaultLanguage = layoutstate.language.languages.find(function (it) { return it.id === layoutstate.language.current; }).code1;
    var lang = searchSet.languageId ? layoutstate.language.languages.find(function (it) { return it.id === searchSet.languageId; }).code1 : defaultLanguage;
    var type = SfilterTypeGroup_1.SfilterType.toString(SfilterTypeGroup_1.ListingPurposeType.toSfilterType(searchSet.listingTypeId));
    if (type)
        type = "/" + type;
    if (searchSet.searchSaveSetType === SaveSearchSet_1.SearchSaveSetType.District && searchSet.district) {
        var districtId_1 = parseInt(searchSet.district.split(',')[0], 10);
        var districtName = HfilterDistrictItem_init_1.defaultHfilterDistrictItems.find(function (it) { return it.id === districtId_1; }).name;
        var districtNameNormalized = format_1.default.normalize(districtName);
        return "/" + lang + "/district/" + districtNameNormalized + type + "/" + districtId_1;
    }
    if (searchSet.searchSaveSetType === SaveSearchSet_1.SearchSaveSetType.Building) {
        var buildingId = searchSet.searchSaveSetTypeReferenceId;
        if (!buildingId)
            return '';
        var buildingNameNormalized = format_1.default.normalize(searchSet.keyword);
        return "/" + lang + "/building/" + buildingNameNormalized + type + "/" + buildingId;
    }
    if (searchSet.searchSaveSetType === SaveSearchSet_1.SearchSaveSetType.Block) {
        var buildingblockId = searchSet.searchSaveSetTypeReferenceId;
        if (!buildingblockId)
            return '';
        var buildingblockNameNormalized = format_1.default.normalize(searchSet.keyword);
        return "/" + lang + "/block/" + buildingblockNameNormalized + type + "/" + buildingblockId;
    }
    var hfilter = UpdateSaveSearchCallSaga_1.searchSetToHfilter(searchSet, currentHfilter);
    var searchQuery = SfavSaveSearchSaga_1.hfilterToSearchQuery(hfilter, searchSet.currencyId, searchSet.languageId);
    var searchQueryWithMap = SfavSaveSearchSaga_1.applyMapSearchToSearchQuery(searchQuery, searchSet);
    var url = searchQueryToUrl_1.searchQueryToUrl(searchQueryWithMap);
    var searchId = searchSet.userSearchSetId;
    return url + "#searchid=" + searchId;
};
